import { Component, OnInit, inject } from '@angular/core';
import { SharedSignalsService } from '../common/services/shared-signals.service';

@Component({
  selector: 'taly-page-under-maintenance',
  templateUrl: './page-under-maintenance.component.html',
  styleUrl: './page-under-maintenance.component.scss',
  standalone: false,
})
export class PageUnderMaintenanceComponent implements OnInit {
  private transferSignal = inject(SharedSignalsService);

  ngOnInit(): void {
    this.transferSignal.setHeader(false);
    this.transferSignal.setFooter(false);
  }
}
